/** Same staff-role set as the backend's OrderController/StaffMessageController and AppComponent.isStaff. */
export const STAFF_ROLES = ['DRIVER', 'COLLECTOR', 'OFFICER', 'PLANNER', 'CONTROLLER', 'MANAGER', 'ADMIN'] as const;
/** Every role that owns a dashboard: the staff roles plus TEAMBOARD, a display-only role (lowest role_order) that
 * is deliberately not in STAFF_ROLES - it must not get the generic staff tiles or staff menu entries. */
export const DASHBOARD_ROLES = ['TEAMBOARD', ...STAFF_ROLES] as const;
export type StaffRoleName = typeof DASHBOARD_ROLES[number];

export function isStaffRoleName(value: string): value is StaffRoleName {
  return (DASHBOARD_ROLES as readonly string[]).includes(value);
}

export interface DashboardConfig {
  label: string;
  description: string;
}

/** Placeholder content for story #10: one dashboard per role, dummy content only. */
export const DASHBOARD_CONFIG: Record<StaffRoleName, DashboardConfig> = {
  TEAMBOARD: {label: 'Teamboard', description: 'Fahrzeugbesatzungen der gewählten Touren.'},
  DRIVER: {label: 'Fahrer-Dashboard', description: 'Dummy-Inhalt für die Rolle Fahrer.'},
  COLLECTOR: {label: 'Sammler-Dashboard', description: 'Dummy-Inhalt für die Rolle Sammler.'},
  OFFICER: {label: 'Büro-Dashboard', description: 'Dummy-Inhalt für die Rolle Sachbearbeiter.'},
  PLANNER: {label: 'Planer-Dashboard', description: 'Dummy-Inhalt für die Rolle Planer.'},
  CONTROLLER: {label: 'Controller-Dashboard', description: 'Dummy-Inhalt für die Rolle Controller.'},
  MANAGER: {label: 'Manager-Dashboard', description: 'Dummy-Inhalt für die Rolle Manager.'},
  ADMIN: {label: 'Admin-Dashboard', description: 'Dummy-Inhalt für die Rolle Admin.'}
};
